import React from "react";
import thumbnail from "../../Assets/Images/BG.png"; // Your thumbnail image
import { FaPlay } from "react-icons/fa";

const BusinessSection = () => {
  return (
    <section className="business-section">
      <div className="container">
        <div className="text-content">
        <h2 className="text-content-h2">
          Excellence for Every <br />
          <span>Business & Sector</span>
        </h2>
        <h2 className="business-section-h2">
          Excellence for Every <span>Business & Sector</span>
        </h2>
        <p className="text-content-para">
          Fast, affordable, and reliable ISO certification — guided by <br/> experts
          for a smooth, stress-free process.<br/> Achieve compliance with confidence
          and grow your<br/> business to global standards.
        </p>
        <p className="business-section-para">
          Fast, affordable, and reliable ISO certification — guided by  experts
          for a smooth, stress-free process. Achieve compliance with confidence
          and grow your business to global standards.
        </p>
      </div>

      <div className="video-wrapper mt-5">
        <img src={thumbnail} alt="Business Thumbnail" className="thumbnail" />
        <div className="play-button">
          <FaPlay />
        </div>
      </div>
      </div>
    </section>
  );
};

export default BusinessSection;
